import axios from '@/lib/axios'
import type { CustomAxiosRequestConfig } from '@/interfaces/customAxiosRequestConfig'
import type { Invoice } from '@/modules/invoices/interfaces/invoice'
import { useQuery } from '@tanstack/vue-query'
import { computed, type MaybeRef } from 'vue'
import { get } from '@vueuse/core'

const fetchInvoice = async (requestId: number): Promise<Invoice | null> => {
	const { data } = await axios.get<{ data: Invoice }>(
		`/api/requests/${requestId}/invoice`,
		{ errorHandling: false } as CustomAxiosRequestConfig,
	)
	return data.data
}

export const invoiceKey = (requestId: number) => ['request-invoice', requestId] as const

const useInvoice = (requestId: number, enabled: MaybeRef<boolean> = true) => {
	const { data, isLoading } = useQuery({
		queryKey: invoiceKey(requestId),
		queryFn: () => fetchInvoice(requestId),
		enabled: computed(() => get(enabled)),
		retry: false,
	})

	return { invoice: computed(() => data.value ?? null), isLoading }
}

export default useInvoice
